var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcContentCopy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "content_copy_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.694,
    height: 16.694,
    viewBox: "0 0 16.694 16.694",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M0,0H16.694V16.694H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M11.738,1H3.391A1.4,1.4,0,0,0,2,2.391v9.738H3.391V2.391h8.347Zm2.087,2.782H6.173A1.4,1.4,0,0,0,4.782,5.173v9.738A1.4,1.4,0,0,0,6.173,16.3h7.651a1.4,1.4,0,0,0,1.391-1.391V5.173A1.4,1.4,0,0,0,13.825,3.782Zm0,11.129H6.173V5.173h7.651Z",
    transform: "translate(-0.609 -0.304)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContentCopy);
export default __webpack_public_path__ + "static/media/ic_content-copy.46bfc356fd92f7b87055b29de4199e80.svg";
export { ForwardRef as ReactComponent };